import React from "react";
import './ProfilePageStyle.css';

export default class ProfilePageComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <div>
                Profile Page
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/Main/ProfilePage/ProfilePage.js